'use client';
import HoverableImage from 'components/HoverableImage';
import { addRandomKey } from 'helpers/utils';
import PropTypes from 'prop-types';
import css from 'styled-jsx/css';

const ProductImagesBlock = ({ items }) => {
    const { className, styles } = css.resolve`
        img {
            width: 100%;
            display: block;
        }
    `;

    return (
        <>
            {addRandomKey(items).map((item) => {
                return (
                    <div key={item.randomKey}>
                        <HoverableImage
                            src={item.image_desktop.url}
                            className={`${className} hidden_on_mobile`}
                            alt={item.image_desktop.alt || 'Hover image'}
                        />
                        <HoverableImage
                            src={item.image_mobile.url}
                            className={`${className} hidden_on_desktop`}
                            alt={item.image_mobile.alt || 'Hover image'}
                        />
                    </div>
                );
            })}
            {styles}
        </>
    );
};

ProductImagesBlock.propTypes = {
    items: PropTypes.array.isRequired,
};

export default ProductImagesBlock;
